import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { variables }                    from './variables';

const options: ThemeOptions = {
  palette: {
    primary: {
      main: variables.colors.primary,
    },
    secondary: {
      main: variables.colors.secondary,
    },
    error: {
      main: variables.colors.red,
    },
  },

  overrides: {
    MuiFormControl: {
      marginDense: {
        marginTop    : 4,
        marginBottom : 4,
      },
    },

    MuiButton: {
      root: {
        fontSize      : 16,
        fontWeight    : 400,
        margin        : 5,
        minWidth      : 160,
        paddingTop    : 8,
        paddingBottom : 8,
        lineHeight    : 'initial',

      },
      label: {
        textTransform: 'none',
      },
      outlined: {
        paddingTop    : 7,
        paddingBottom : 7,
      },
      sizeSmall: {
        fontSize      : 14,
        minWidth      : 80,
        paddingTop    : 6,
        paddingBottom : 6,
      },
      colorInherit: {
        color           : variables.colors.white,
        backgroundColor : variables.colors.red,
        '&:hover'       : {
          backgroundColor: variables.colors.darkRed,
        },
      },
      textSecondary: {
        textAlign : 'left',
        color     : variables.colors.secondary,
      },
      outlinedSecondary: {
        color           : variables.colors.secondary,
        backgroundColor : variables.colors.white,
      },
      containedSecondary: {
        color           : variables.colors.white,
        backgroundColor : variables.colors.secondary,
      },
    },

    MuiInputBase: {
      formControl: {
        backgroundColor: variables.colors.white,
      },
    },

    MuiOutlinedInput: {
      root: {
        '&$focused': {
          borderColor: variables.colors.secondary,
        },
      },
    },

    MuiInputAdornment: {
      root: {
        color           : variables.colors.darkGray,
        backgroundColor : variables.colors.white,
      },
      marginDense: {
        '& svg': {
          fontSize : 18,
          fill     : variables.colors.darkGray,
        },
      },
    },

    MuiTableRow: {
      root: {
        height: 40,
      },
    },

    MuiTableCell: {
      root: {
        padding: '0 10px',
      },
    },
  },
};

export const muiTheme = createMuiTheme(options);
